import React from "react";
import { Link } from "react-router-dom";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="font-mono-tech text-xs tracking-[0.2em] uppercase text-mutedgray" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <span key={i}>
          {it.to ? (
            <Link to={it.to} className="hover:text-offwhite transition-colors" data-testid={`crumb-${i}`}>{it.label}</Link>
          ) : (
            <span className="text-offwhite">{it.label}</span>
          )}
          {i < items.length - 1 && <span className="px-3 text-strike">/</span>}
        </span>
      ))}
    </nav>
  );
}
